import axios from "axios";
import _ from "lodash";
import Endpoint from "../../constants/endpoint";

// state
const state = {
    priceOilType: "",
    addPriceOilType: "",
    lastPriceOilType: {}
  };
  
  const getters = {
    getterPriceOilType(state) {
      console.log(state.priceOilType);
      return state.priceOilType;
    },
    getterLastPriceOilType(state) {
      // console.log(state.lastPriceOilType.price);
      return state.lastPriceOilType.price;
    },
  };
  
  const actions = {
    async findAllPriceOilTypeLog(context, data) {
      context.commit("LOADING", { loading: true });
      const url = Endpoint.findAllPriceOilTypeLog();
      await axios
        .get(url)
        .then((res) => {
            const data = _.get(res, "data", []);
            context.commit("SUCCESS_GET_PRICE_OIL_TYPE", { data });
        })
        .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
        })
        .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
    },
    async addPriceOilTypeLog(context, {price,oil_id,name_th}) {
        context.commit("LOADING", { loading: true });
        const url = Endpoint.addPriceOilTypeLog();
        await axios
          .post(url, {price,oil_id,name_th})
          .then((res) => {
            const data = _.get(res, "data", []);
            if (res.data) {
              context.commit("SUCCESS_SET_PRICE_OIL_TYPE", { data });
            }
          })
          .catch((e) => {
            context.commit("ERROR_VESSEL_TRIP", { error: e });
          })
          .finally(() => {
          context.commit("LOADING_VESSEL_TRIP", { loading: false });
        });
      },
    async findPriceOilTypeLogByOilId(context, oil_id) {
      context.commit("LOADING", { loading: true });
      const config = {
        params: {
          "oil_id": oil_id
        },
      };
      const url = Endpoint.findPriceOilTypeLogByOilId();
      await axios
        .get(url,config)
        .then((res) => {
          const data = _.get(res, "data", []);
          context.commit("SUCCESS_GET_LAST_PRICE_OIL_TYPE", { data });
        })
        .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
        })
        .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
    },
  };
  
  const mutations = {
    // mutations
    SUCCESS_GET_PRICE_OIL_TYPE(state, payload) {
      state.priceOilType = payload.data;
    },
    SUCCESS_SET_PRICE_OIL_TYPE(state, payload) {
      state.addPriceOilType = payload.data;
    },
    SUCCESS_GET_LAST_PRICE_OIL_TYPE(state, payload) {
      state.lastPriceOilType = payload.data;
    },
  };
  
  export default {
    state,
    getters,
    actions,
    mutations,
  };
  